import { FC } from 'react'
import styled from 'styled-components'
import { media, fonts } from 'shared/lib'
import { repeat } from 'lodash/fp'
import Image from 'shared/components/Image'
import { t } from 'localization'

const TP = 'shared.components.PhotosGrid'

const Grid = styled.div<{ maxColumns: number }>`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr;
  ${media.large`
    ${({ maxColumns }) => `grid-template-columns:${repeat(maxColumns)(' 1fr')};`}
  `}
`
const Title = styled.h3`
  ${fonts.SUBTITLE_2}
  margin: 20px 0;
`

interface IPhotosGridProps {
  photos: string[]
  maxColumns?: number
  lazyLoad?: boolean
  noPhotosMessage?: string
  title?: string
  imageSizes?: string
}

const PhotosGrid: FC<IPhotosGridProps> = ({
  photos,
  maxColumns = 2,
  lazyLoad = false,
  noPhotosMessage = t(`${TP}.noPhotosFound`, 'No Photos Found.'),
  title,
  imageSizes,
}) => {
  return !!photos?.length ? (
    <>
      {title && <Title data-testid="photos-grid-title">{title}</Title>}
      <Grid maxColumns={maxColumns} data-testid="photos-grid">
        {photos.map(photo => (
          <Image
            data-testid="photos-grid-image"
            alt={t(`${TP}.photosGridAlt`, 'photo grid image')}
            src={photo}
            disableLazyLoad={!lazyLoad}
            sizes={imageSizes}
            key={photo}
          />
        ))}
      </Grid>
    </>
  ) : (
    <div>
      <Title data-testid="no-photos-message">{noPhotosMessage}</Title>
    </div>
  )
}

export default PhotosGrid
